
// src/pages/Partners.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import "./Partner.css";

export default function Partners() {
  const [partners, setPartners] = useState([]);
  const [activeTab, setActiveTab] = useState("approved"); // "approved" or "proposed"
  const navigate = useNavigate();

  // 实时订阅 Firestore 集合 /partners
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "partners"),
      (snapshot) => {
        const list = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPartners(list);
      },
      (error) => {
        console.error("Error fetching partners:", error);
      }
    );
    return () => unsub();
  }, []);

  // 根据 activeTab 过滤数据
  const filtered = partners.filter((p) => p.status === activeTab);

  return (
    <div className="partner-container">
      {/* ── Banner ── */}
      <div className="partner-banner" style={{ position: "relative" }}>
        <Link
          to="/our-company"
          className="apply-back-btn"
          style={{
            position: "absolute",
            top: 24,
            left: 24,
            background: "rgba(255,255,255,0.15)",
            color: "#fff",
            backdropFilter: "blur(4px)",
          }}
        >
          ← Back
        </Link>

        <div className="partner-banner-content">
          <h1>Our Partners</h1>
          <p className="partner-tagline">
            We welcome all types of partnerships.
            <br />
            At Lex, we believe win-win collaboration drives long-term success.
          </p>
          <button
            className="partner-now-btn"
            onClick={() => navigate("/partners/apply")}
          >
            Partner Now
          </button>
        </div>
      </div>

      {/* ── Tabs ── */}
      <div className="partner-tabs">
        <button
          className={`partner-tab-btn ${
            activeTab === "approved" ? "is-active" : ""
          }`}
          onClick={() => setActiveTab("approved")}
        >
          Partners
        </button>
        <button
          className={`partner-tab-btn ${
            activeTab === "proposed" ? "is-active" : ""
          }`}
          onClick={() => setActiveTab("proposed")}
        >
          Proposed
        </button>
      </div>

      {/* ── Card Grid ── */}
      <div className="partner-grid">
        {filtered.map((p) => {
          // 处理 hashtags：兼容数组或逗号分隔字符串
          const tags = Array.isArray(p.hashtags)
            ? p.hashtags
            : (p.hashtags || "")
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean);

          return (
            <Link
              to={`/partners/${p.id}`}
              className="partner-card"
              key={p.id}
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              {p.logo ? (
                <img src={p.logo} alt={p.name} className="partner-logo" />
              ) : (
                <div className="partner-logo-placeholder" />
              )}

              <h3 className="partner-name">{p.name}</h3>
              <p className="partner-desc">{p.description}</p>

              {tags.length > 0 && (
                <div className="partner-hashtags">
                  {tags.slice(0, 4).map((t) => (
                    <span key={t}>#{t}</span>
                  ))}
                  {tags.length > 4 && <span>+{tags.length - 4}</span>}
                </div>
              )}

              {p.status === "approved" && (
                <div className="partner-link">Learn More →</div>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
